import { render, staticRenderFns } from "./TemplatesView.vue?vue&type=template&id=35138e63&"
import script from "./TemplatesView.vue?vue&type=script&lang=ts&"
export * from "./TemplatesView.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatesView.vue?vue&type=style&index=0&id=35138e63&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports